import { render, staticRenderFns } from "./pageAuth.vue?vue&type=template&id=f20ed9b2&"
import script from "./pageAuth.vue?vue&type=script&lang=js&"
export * from "./pageAuth.vue?vue&type=script&lang=js&"
import style0 from "./pageAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports